
export default function TabNav({ active, onChange }) {
  const tabs = [
    { id:'football', label:'Football',   icon:'⚽' },
    { id:'f1',       label:'Formula 1',  icon:'🏎️' },
    { id:'multi',    label:'Multiplayer',icon:'📱' },
  ];
  return (
    <nav className="tab-nav">
      {tabs.map(t => (
        <button key={t.id}
          className={'tab-btn'+(active===t.id?' active-'+t.id:'')}
          onClick={() => onChange(t.id)}>
          <span className="tab-icon">{t.icon}</span>
          {t.label}
        </button>
      ))}
    </nav>
  );
}
